export default {
  install: (Vue, { state }) => {
    Vue.state = state;
  }
}



// WEBPACK FOOTER //
// ./_common/plugins/state.plugin.js